import React, { Component } from 'react';
import {ProductBrief} from 'components/partials/product';
import {UserInfo} from 'components/partials/userinfo';
import {Demands} from 'api';
import {ShowIf} from 'components/utils';
import {DemandConversationsContainer, NeedOffersForwardContainer} from 'components/demands';

class DemandDetail extends Component {
  constructor(propx, context) {
    super(propx, context);

    this.state = {
      id: this.props.id
    }
  }

  componentDidMount() {

  }

  render() {
    return (
      <div>
        <h1 className='user-header'>Thông tin người gửi</h1>
        <section className="list-demand">
          <UserInfo user={this.props.user}/>
          <div className='list-demand-wrap'>
          </div>
        </section>
        <br/>
        <h1 className='user-header'>Nội dung</h1>
        <div>
          <p>{this.props.content}</p>
        </div>
        <NeedOffersForwardContainer idDemand={this.props.id} demand={this.props}/>
        <DemandConversationsContainer demand={this.props}/>
      </div>


    );
  }

}

export default DemandDetail;



// WEBPACK FOOTER //
// ./components/demands/DemandDetail.jsx